import type {
  Data, Variables, Cache, UpdatesConfig,
} from '@urql/exchange-graphcache';

import invalidateQuery from '@/graphql/config/cache/util/invalidateQuery';

const refundPolicyDecisionExchange: UpdatesConfig['Mutation'] = {
  refundPolicyDecisionCreate: (_: Data, __: Variables, cache: Cache) => invalidateQuery(
    ['refundPolicyDecisions', 'tuitionOffer'],
    cache,
  ),
};

export default refundPolicyDecisionExchange;
